
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[tipo]",
      function () {
        return require("private-next-pages/auth/[tipo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/[tipo]"])
      });
    }
  